import React from 'react';
import { ControlLabel } from 'rsuite';
import { FilterCheckbox } from './FilterCheckbox';
import { FilterCombo } from './FilterCombo';
import { FilterComboMulti } from './FilterComboMulti';
import { FilterSlider } from './FilterSlider';
import { FilterText } from './FilterText';

export const Filter = ({ label, filter }) => {
  // console.log({ filter });

  let field = null;

  if (filter.field === 'select') {
    field = <FilterCombo name={filter.name} placeholder={filter.all} />;
  } else if (filter.field === 'select-checkboxes') {
    field = <FilterComboMulti name={filter.name} placeholder={filter.all} />;
  } else if (filter.field === 'slider') {
    field = <FilterSlider name={filter.name} />;
  } else if (filter.field === 'text') {
    field = <FilterText name={filter.name} placeholder={filter.all} />;
  } else if (filter.field === 'checkbox') {
    field = <FilterCheckbox name={filter.name} text={filter.text} />;
  }

  return (
    <>
      {label && <ControlLabel>{filter.label}</ControlLabel>}
      {field}
    </>
  );
};
